module.exports = __webpack_public_path__ + "2026 Qualified Transit User Guide.pdf";